module.exports = __webpack_public_path__ + "static/media/position-hierarchy.074421c8.svg";